import {api} from "../../../config/api";
import secureStorage from "../../../utils/secureStorage";

// Réglages > Calendrier — clicoo CalendarController (/api/calendar/*).
// Opening hours and rest days are pushed to the tablets on save
// (catalogue_updated), in the exact format they use locally.

export const DAY_KEYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

export const DAY_LABELS = {
    monday: "Lundi",
    tuesday: "Mardi",
    wednesday: "Mercredi",
    thursday: "Jeudi",
    friday: "Vendredi",
    saturday: "Samedi",
    sunday: "Dimanche",
};

// days_of_week of a rest day: 0 = dimanche … 6 = samedi (tablets' convention),
// listed Monday first.
export const WEEKDAYS = [
    {id: 1, short: "Lun"},
    {id: 2, short: "Mar"},
    {id: 3, short: "Mer"},
    {id: 4, short: "Jeu"},
    {id: 5, short: "Ven"},
    {id: 6, short: "Sam"},
    {id: 0, short: "Dim"},
];

// Same choices as the tablets' pickers: quarter hours, opening hours 9h-20h
// (Réglages > Calendrier on the POS), rest days 9h-23h.
export const timeSlots = (minHour, maxHour) => {
    const slots = [];
    for (let hour = minHour; hour <= maxHour; hour++) {
        for (let minutes = 0; minutes < (hour === maxHour ? 1 : 60); minutes += 15) {
            slots.push(hour + minutes / 60);
        }
    }
    return slots;
};

// 9.5 → "09:30"
export const formatHour = (value) => {
    const totalMinutes = Math.round(Number(value) * 60);
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
};

const headers = async () => {
    const account = await secureStorage.getItem("selectedAccount");
    return {"X-account-id": account?.id, Accept: "application/json"};
};

export const apiErrorMessage = (error, fallback) =>
    error?.response?.data?.error || error?.response?.data?.detail || fallback;

// {hours: {monday: {closed, start, end}, …} | null}
export const fetchCalendarHours = async () => {
    const {data} = await api.get("/calendar/hours", {headers: await headers()});
    return data?.hours ?? null;
};

export const updateCalendarHours = async (hours) => {
    const {data} = await api.put("/calendar/hours", {hours}, {headers: await headers()});
    return data?.hours ?? null;
};

// {rest_days: [...], employees: [{id, name, color}]}
export const fetchRestDays = async ({from} = {}) => {
    const query = from ? `?from=${encodeURIComponent(from)}` : "";
    const {data} = await api.get(`/calendar/rest-days${query}`, {headers: await headers()});
    return {restDays: data?.rest_days || [], employees: data?.employees || []};
};

export const createRestDays = async (payload) => {
    const {data} = await api.post("/calendar/rest-days", payload, {headers: await headers()});
    return data?.rest_days || [];
};

export const updateRestDay = async (id, changes) => {
    const {data} = await api.put(`/calendar/rest-days/${id}`, changes, {headers: await headers()});
    return data;
};

export const deleteRestDay = async (id) => {
    await api.delete(`/calendar/rest-days/${id}`, {headers: await headers()});
};
